// extracted by mini-css-extract-plugin
module.exports = {"Registration":"Registration_Registration__nofvQ","Content":"Registration_Content__1u6V8","Buttons":"Registration_Buttons__2_uC8"};